import {
    GRID_ACTIONS_COLUMN_TYPE,
    GRID_CHECKBOX_SELECTION_COL_DEF,
    GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
    GRID_REORDER_COL_DEF,
    GridColumnVisibilityModel,
    GridPinnedColumns
} from '@mui/x-data-grid-pro';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { IGridOption } from '../types';
import { DEFAULT_GRID_PREFERENCE_PAGESIZE } from '../GridOptions/utils';

export const generateGridOptionsToSave = (actualState: GridInitialStatePro, densityFactor: number) => {
    const { columns, filter, pagination, sorting } = actualState;

    if (!columns) throw Error('columns are not defined');

    const hiddenFields = getHiddenFields(columns.columnVisibilityModel || {});
    const orderedFields = getOrderedFields(columns.orderedFields || []);
    const pinnedColumns = getPinnedColumns(actualState.pinnedColumns || null);
    const filterModel = filter?.filterModel?.items
        ?.map(({ id, field, operator, ...item }) => ({
            value: item.value,
            columnField: field,
            operatorValue: [actualState.filter?.filterModel?.logicOperator?.toLocaleUpperCase(), operator]
        }))
        .map((filterItem) => {
            const hasSort = sorting?.sortModel?.find((el) => el.field === filterItem.columnField);
            return { ...filterItem, operatorValue: hasSort ? [...filterItem.operatorValue, hasSort.sort] : filterItem.operatorValue };
        });
    const pageSize = Math.min(200, pagination?.paginationModel?.pageSize ?? DEFAULT_GRID_PREFERENCE_PAGESIZE);

    const filterModelFields = (filterModel || []).map((el) => el.columnField);
    const fieldsWithoutFilterWithSort = sorting?.sortModel?.filter((el) => !filterModelFields.includes(el.field));
    if (fieldsWithoutFilterWithSort)
        for (const field of fieldsWithoutFilterWithSort) {
            filterModel?.push({
                columnField: field.field,
                operatorValue: ['', '', field.sort],
                value: ['']
            });
        }
    return [
        {
            pageSize,
            orderedFields,
            pinnedColumns,
            hiddenFields,
            densityFactor,
            filterModel
        }
    ] as IGridOption[];
};

export const getPinnedColumns = (pinnedColumns: GridPinnedColumns | null): GridPinnedColumns | null => {
    if (!pinnedColumns) return null;
    return {
        left:
            pinnedColumns.left?.filter(
                (field) =>
                    ![GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field, GRID_CHECKBOX_SELECTION_COL_DEF.field, GRID_ACTIONS_COLUMN_TYPE].includes(
                        field
                    )
            ) || [],
        right: pinnedColumns.right || []
    };
};

export const getHiddenFields = (visibilityModel: GridColumnVisibilityModel) =>
    Object.keys(visibilityModel).filter((key) => !visibilityModel[key]);

export const getOrderedFields = (orderedFields: string[]) =>
    orderedFields.filter(
        (field) =>
            ![GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field, GRID_REORDER_COL_DEF.field, GRID_CHECKBOX_SELECTION_COL_DEF.field].includes(field)
    );
